module.exports = __webpack_public_path__ + "static/media/cc-dark.74ef8ce9.png";